import { render, staticRenderFns } from "./pushbtn.vue?vue&type=template&id=c671493e&scoped=true"
import script from "./pushbtn.vue?vue&type=script&lang=js"
export * from "./pushbtn.vue?vue&type=script&lang=js"
import style0 from "./pushbtn.vue?vue&type=style&index=0&id=c671493e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c671493e",
  null
  
)

export default component.exports